import React from "react";

import PhotoModLargeUploadImage from "../PhotoModLargeUploadImage";

const PhotoModCarouselImage = ({ uploadId }) => {
    return <PhotoModLargeUploadImage uploadId={uploadId} />;
};

export default PhotoModCarouselImage;
